// This is just a placeholder file for the 'Edit' theme.
// View source the files in the `source/templates` directory for the actual templates used in the Edit theme.

module.exports = (
	{
		TemplatePrefix: 'PictProvider-Theme-Edit',
		Templates: [],
	}
);
